import backend, {WORKFLOW_ENGINE_API} from 'utils/backend/server/api_library';

const createAutomation = (taskRule) => {
  const url = `${WORKFLOW_ENGINE_API}/task_rule`;
  const body = taskRule;
  return backend.post(url, body);
};

const getAutomations = () => {
  const url = `${WORKFLOW_ENGINE_API}/task_rule`;
  return backend.get(url);
};

const updateAutomation = (taskRuleRn, taskRule) => {
  const url = `${WORKFLOW_ENGINE_API}/task_rule/${taskRuleRn}`;
  const body = taskRule;
  return backend.put(url, body);
};

const deleteAutomation = (taskRuleRn) => {
  const url = `${WORKFLOW_ENGINE_API}/task_rule/${taskRuleRn}`;
  return backend.delete(url);
};


export default {
  createAutomation,
  getAutomations,
  updateAutomation,
  deleteAutomation,
};
